import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs/Subscription'
import { DocumentsService } from '../../../services/documents.service'
import { DocumentModel } from '../../../models/document.model'
import { ActivatedRoute, Router } from '@angular/router'
import { dutchDocument } from '../i18n/nl'
import { dutch } from '../../../content/administrations/i18n/nl'
import { FuseTranslationLoaderService } from '../../../../core/services/translation-loader.service'
import { MatSnackBar } from '@angular/material'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-document-details',
  templateUrl: './document-details.component.html',
  styleUrls: ['./document-details.component.scss'],
})
export class DocumentDetailsComponent implements OnInit, OnDestroy {
  public document: DocumentModel
  public showToolBar = false

  constructor(
    private _translationLoader: FuseTranslationLoaderService,
    private _documentService: DocumentsService,
    private _activeRoute: ActivatedRoute,
    private _router: Router,
    private translateService: TranslateService,
    public snackBar: MatSnackBar,
  ) {
    this._translationLoader.loadTranslations(dutchDocument, dutch)
  }

  ngOnInit() {
    this.document = this._activeRoute.snapshot.data.document
    if (this.document.status_reason === 'REJECTED_BEFORE_START_DATE') {
      this.showToolBar = true
    }
  }

  ngOnDestroy(): void {}

  /**
   *
   * @param document
   */
  public rejectDocument(document: DocumentModel) {
    this._documentService.reject(document.id).subscribe(
      response => {
        this.translateService.get('DOCUMENTS.REJECTED', {}).subscribe((message: string) => {
          this.openSnackBar(message, '', 'success')
        })
      },
      errors => {
        this.translateService.get('DOCUMENTS.FAILED_TO_REJECT', {}).subscribe((message: string) => {
          this.openSnackBar(message, '', 'error')
        })
      },
    )
  }

  /**
   *
   * @param document
   */
  public processDocument(document: DocumentModel) {
    this._documentService.process(document.id).subscribe(
      response => {
        this.showToolBar = false
        this.translateService.get('DOCUMENTS.APPROVED', {}).subscribe((message: string) => {
          this.openSnackBar(message, '', 'success')
        })
      },
      errors => {
        this.translateService.get('DOCUMENTS.FAILED_TO_APPROVE', {}).subscribe((message: string) => {
          this.openSnackBar(message, '', 'error')
        })
      },
    )
  }

  public back(event: Event) {
    this._router.navigate(['/documents'])
  }

  /**
   *
   * @param {string} message
   * @param {string} action
   * @param {string} type
   */
  openSnackBar(message: string, action: string, type: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
      panelClass: [type + '-snackbar'],
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/documents/document-details/document-details.component.ts